import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Badge } from "react-bootstrap";

const Account = () => {
    return (
    <>
        My Account
    </>
  );
};

export default Account;